"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = Container;
const React = __importStar(require("react"));
const LocalElements = __importStar(require("../../elements"));
const Types = __importStar(require("../../types"));
const TestNodeRenderer = __importStar(require("./test-node-renderer"));
const client_config_1 = require("../../../../../../client-config");
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
function Container(props) {
    // const [isOpen, toggle] = React.useState(false);
    React.useEffect(() => {
        if (props.status === Types.Status.Idle) {
            props.runRequest();
        }
    });
    if (props.status === Types.Status.Waiting) {
        return (React.createElement(React.Fragment, null,
            React.createElement(WaitingRow, Object.assign({}, props)),
            React.createElement("tr", null,
                React.createElement("td", { colSpan: 5 }))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(NormalRow, Object.assign({}, props)),
        React.createElement(ResultRow, Object.assign({}, props))));
}
function ResultRow(props) {
    return (React.createElement("tr", null,
        React.createElement("td", { colSpan: 5 }, props.result &&
            (props.result.type === "result" ? (React.createElement(TestNodeRenderer.Component, { isExpanded: props.systemIsExpanded, result: props.result, toggleExpand: path => {
                    props.toggleNode(props.internalId, path);
                } })) : (props.systemIsExpanded && (React.createElement(LocalElements.ErrorContainer, null,
                React.createElement(LocalElements.NodeList, null,
                    React.createElement("li", null,
                        React.createElement("img", { src: "/assets/images/status-error.png", width: 12, height: 12 }),
                        props.result.errorText)))))))));
}
function WaitingRow(props) {
    return (React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement(LocalElements.NodeHeader, null,
                React.createElement(LocalElements.NodeTitle, null,
                    React.createElement("span", { style: { marginLeft: "30px", display: "block" } }, "System is in queue")))),
        React.createElement("td", null, props.systemType),
        React.createElement(SystemCell, { genesysNo: props.referenceSystemNo, revisionNo: props.referenceSystemRev }, props.referenceSystemNo + "-" + props.referenceSystemRev),
        React.createElement("td", null),
        React.createElement("td", null, Types.Status[props.status])));
}
function NormalRow(props) {
    const statusCell = React.createElement("td", null, Types.Status[props.status]);
    const nameCell = (React.createElement(NameCell, { status: props.status, isExpanded: props.systemIsExpanded, isOk: props.systemRowIsOk, referenceSystemName: props.referenceSystemName, expandSystemToggle: props.toggleSystem }));
    const referenceSystemCell = (React.createElement(SystemCell, { genesysNo: props.referenceSystemNo, revisionNo: props.referenceSystemRev }, props.referenceSystemNo + "-" + props.referenceSystemRev));
    if (props.rowType === "nevada") {
        return (React.createElement("tr", null,
            nameCell,
            React.createElement("td", null, props.status >= Types.Status.Calculating && props.systemType),
            referenceSystemCell,
            React.createElement(SystemCell, { genesysNo: props.testSystemNo, revisionNo: props.testSystemRev }, !!(props.status >= Types.Status.Calculating && props.testSystemRev) && props.testSystemNo + "-" + props.testSystemRev),
            statusCell));
    }
    return (React.createElement("tr", null,
        nameCell,
        React.createElement("td", null, props.systemType),
        referenceSystemCell,
        React.createElement(SystemCell, { genesysNo: props.testSystemNo, revisionNo: props.testSystemRev }, props.testSystemNo + "-" + props.testSystemRev),
        statusCell));
}
function SystemCell({ genesysNo, revisionNo, children }) {
    const genesysUrl = client_config_1.config.genesysBackend;
    const prefix = getGenesyPrefix(client_config_1.config.environment);
    const systemCellOnclick = () => {
        window.open(`${genesysUrl}/system/${prefix}${genesysNo}-${revisionNo}`);
    };
    return (React.createElement("td", null,
        React.createElement(LocalElements.SystemLink, { onClick: systemCellOnclick }, children)));
}
function NameCell({ status, isOk, isExpanded, referenceSystemName, expandSystemToggle }) {
    return (React.createElement("td", null,
        React.createElement(LocalElements.NodeHeader, { onClick: () => {
                if (status >= Types.Status.Complete) {
                    expandSystemToggle();
                }
            } },
            React.createElement(LocalElements.NodeExpander, null, status >= Types.Status.Complete && (isExpanded ? "-" : "+")),
            status === Types.Status.Complete ? (isOk ? (React.createElement(LocalElements.ResultVisualizer, { src: "/assets/images/errors/ok.svg" })) : (React.createElement(LocalElements.ResultVisualizer, { src: "/assets/images/errors/error.svg" }))) : (React.createElement(LocalElements.ResultVisualizer, { src: "/assets/images/spin.svg" })),
            React.createElement(LocalElements.NodeTitle, null, status >= Types.Status.Calculating && referenceSystemName))));
}
function getGenesyPrefix(enviroment) {
    switch (enviroment) {
        case "localhost":
        case "Develop": {
            return "D";
        }
        case "Staging": {
            return "S";
        }
        case "Production": {
            return "G";
        }
        default:
            return (0, ts_exhaustive_check_1.exhaustiveCheck)(enviroment);
    }
}
//# sourceMappingURL=container.js.map